import React, { useState, useEffect, useRef } from 'react'
import CountUp from 'react-countup';
import "./Counter.css"

const Counter = () => {
  const [startCounting, setStartCounting] = useState(false)
  const statsRef = useRef(null)     

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCounting(true)
        }
      },
      {
        threshold: 0.3, 
        rootMargin: '0px'
      }
    )

    if (statsRef.current) {
      observer.observe(statsRef.current)
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current)
      }
    }
  }, [])

  return (
    <section id="stats" className="wrapper" ref={statsRef}>
        <div className="container">
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 1200 : 0} 
                        duration={2.5} 
                        suffix="+"
                        separator="" 
                    />
                </span>
                <p>Active Agents</p>
            </div>
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 40 : 0} 
                        duration={2.5} 
                        suffix="%"
                    />
                </span>
                <p>Conversion Boost</p>
            </div>
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 20 : 0} 
                        duration={2.5} 
                        suffix="K+"
                    />
                </span>
                <p>Properties Listed</p>
            </div>
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 95 : 0} 
                        duration={2.5} 
                        suffix="%"
                    />
                </span>
                <p>Owners Satisfied</p>
            </div>
        </div>
    </section>
  )
}

export default Counter;